// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { WelcomeAreaRoutes } from '@backoffice-frontend/welcome-api'
import { lazy } from 'react'
import { WelcomeAreaId } from './WelcomeAreaId'

import { WelcomeAreaNavigation } from './WelcomeAreaNavigation'

const LazyWelcomeComponent = lazy(() => import('./WelcomeArea'))

const WelcomeComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyWelcomeComponent />
  </SuspenseLoadingWrapper>
)

export const WelcomeArea = {
  id: WelcomeAreaId,
  NavigationComponent: WelcomeAreaNavigation,
  route: {
    path: WelcomeAreaRoutes.route,
    component: WelcomeComponent,
  },
}
